import {
  fetchingUserData,
  fetchingOrders,
  fetchingNotes,
  fetchingSms,
  fetchingMessages,
  fetchingPhones,
  fetchingTransactions,
  addNote,
  deleteNote,
} from './actions';
export const initialState = {
  fetchingUserData,
  fetchingOrders,
  fetchingNotes,
  fetchingSms,
  fetchingMessages,
  fetchingPhones,
  fetchingTransactions,
  addNote,
  deleteNote,
  customer: null,
  notes: null,
  orders: null,
  allSms: null,
  messages: null,
  phones:null,
  transactions: null,
};

export const reducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'CUSTOMER':
      return { ...state, customer: payload };
    case 'LOAD':
      return {
        ...state,
        [payload.name]: payload.value,
      };
    case 'NOTES':
      return { ...state, notes: payload };
    default:
      return state;
  }
};
